export const stripEms = (data) => data.replace(/(<em>|<\/em>)/g, '', data);

export const value = (item) => {
    if (item.categoryTeaser) {
        return `${stripEms(item.categoryTeaser.heading)} (kategori)`;
    }

    if (item.teaser?.subHeading) {
        return `${stripEms(item.teaser.heading)}: ${stripEms(item.teaser.subHeading)}`;
    }

    return `${stripEms(item.teaser.heading)}`;
};

export const getUrl = (item) => {
    if (item.teaser?.item.urls?.svtplay) {
        return item.teaser.item.urls.svtplay;
    }

    if (item.categoryTeaser) {
        return ['teckensprak', 'syntolkat'].includes(item.categoryTeaser.id)
            ? `/${item.categoryTeaser.id}`
            : `/genre/${item.categoryTeaser.id}`;
    }

    return '/sida-saknas';
};

// Search only handles teasers and category teasers
export const filterValidHits = (result) => {
    if (!result) {
        return [];
    }
    result.hits.filter((item) => item.teaser !== null || item.categoryTeaser !== null);

    return result;
};

export const sortSearchResult = (result) => {
    if (!result.hits) {
        return [];
    }

    result?.hits.sort((item) => {
        switch (item.categoryTeaser?.id) {
            case 'teckensprak':
            case 'tydligare-tal':
            case 'upplast-undertext':
            case 'syntolkat':
                return -1;
            default:
                return 0;
        }
    });

    return result;
};

export const getId = (item) => {
    if (item.categoryTeaser) {
        return `${item.categoryTeaser.id}`;
    }

    if (item.teaser?.item) {
        return `${item.teaser.item.svtId}`;
    }

    return ``;
};

export const getContentId = (item) => {
    if (item.categoryTeaser) {
        return `${stripEms(item.categoryTeaser.heading)}`;
    }

    if (item.teaser?.item) {
        return `${item.teaser.item.svtId}`;
    }

    return ``;
};
